@if (isLoading()) {
  <lib-overlay-loader />
} @else {
  <div
    data-test="user-details-page"
    [class]="floatingPageClasses()"
    [class.flex]="floating()"
    [class.flex-col]="floating()"
    [class.gap-lg]="floating()"
    [class.min-h-full]="floating()">
    <header
      [class.border-b]="!floating()"
      [class.border-neutral-300]="!floating()"
      [class.py-lg]="!floating()">
      <ng-template #backButton>
        <a data-test="user-details-back" (click)="goBack()" class="bg-white">
          <lib-chevron-down-icon
            [iconClass]="'size-10 text-neutral-900 rotate-90 p-sm rounded-lg cursor-pointer border border-neutral-200'" />
        </a>
      </ng-template>

      @if (!floating()) {
        <div class="flex justify-between items-center mb-2xl">
          <ng-container [ngTemplateOutlet]="backButton" />
        </div>
      }

      <div class="flex justify-between items-center">
        <div class="flex gap-lg items-center">
          @if (floating()) {
            <ng-container [ngTemplateOutlet]="backButton" />
          }
          @if (userDetails().image && userDetails().image.url) {
            <img
              [src]="userDetails().image.url"
              [alt]="userDetails().image.name"
              class="rounded-full size-16" />
          } @else {
            <div
              class="avatar flex items-center justify-center rounded-full bg-primary-50">
              <span class="text-2xl rtl:text-xl font-medium text-primary-500">
                {{ userDetails().name | avatar }}
              </span>
            </div>
          }

          <div class="flex flex-col gap-md">
            <div class="flex items-center gap-sm">
              <h2 class="font-semibold text-2xl text-neutral-900">
                {{ userDetails().name }}
              </h2>

              <span class="text-neutral-300 font-semibold no-arabic-font"
                >|</span
              >

              @if (userDetails().identifier) {
                <span class="text-primary-500 font-semibold text-xl">
                  {{ userDetails().identifier }}
                </span>
                <span class="text-neutral-300 font-semibold no-arabic-font"
                  >|</span
                >
              }

              <lib-badge
                [label]="userDetails().state.label"
                [badgeClass]="
                  'px-sm border-none text-sm font-medium text-white ' +
                  (userDetails().state.value | userStatus)
                " />
            </div>

            <p class="text-sm font-medium text-neutral-500">
              #{{ userDetails().id }}
            </p>
          </div>
        </div>

        <a
          [routerLink]="[
            `${ADMIN_ROUTES.USERS_DATABASE.FORM}` | tenantPath: 'admin',
            userId(),
          ]"
          id="user_details_screen_edit_button"
          class="text-primary-600 font-medium text-base py-sm px-2xl border-none rounded-md gap-sm flex items-center">
          <lib-edit-icon [iconClass]="'size-5 text-primary-600'" />

          {{ 'user_details_screen_edit_button' | transloco }}
        </a>
      </div>
    </header>

    <div
      data-test="user-details-card"
      [class.floating-card]="floating()"
      [class.p-2xl]="floating()">
      <section
        data-test="user-details-section"
        [class]="floating() ? 'block' : 'block mt-2xl'">
        <div class="view-mode-section-title py-lg mb-2xl">
          <h6>
            {{ 'user_details_screen_user_info_section_title' | transloco }}
          </h6>
        </div>

        <div
          class="mb-4xl grid [grid-template-columns:repeat(auto-fill,minmax(20rem,1fr))] gap-lg">
          <div>
            <p class="view-mode-label">
              {{ 'user_details_screen_phone_number_label' | transloco }}
            </p>

            <p class="view-mode-value break-word text-neutral-900">
              <span
                [dir]="
                  userDetails().phone?.international_number ? 'ltr' : 'auto'
                ">
                {{
                  userDetails().phone?.international_number
                    ? userDetails().phone?.international_number
                    : ('details_not_found_label' | transloco)
                }}
              </span>
            </p>
          </div>

          <div>
            <p class="view-mode-label">
              {{ 'user_details_screen_email_address_label' | transloco }}
            </p>

            <p class="view-mode-value break-word text-neutral-900">
              {{
                userDetails().email
                  ? userDetails().email
                  : ('details_not_found_label' | transloco)
              }}
            </p>
          </div>

          <div>
            <p class="view-mode-label">
              {{ 'user_details_screen_last_access_label' | transloco }}
            </p>

            <p class="view-mode-value break-word text-neutral-900">
              @if (userDetails().last_accessed_at) {
                <span dir="ltr">
                  {{
                    userDetails().last_accessed_at | date: 'dd-MMM-yyyy hh:mm a'
                  }}
                </span>
              } @else {
                {{ 'details_not_found_label' | transloco }}
              }
            </p>
          </div>
        </div>
      </section>

      <section data-test="user-details-section" class="block mt-2xl">
        <div class="view-mode-section-title py-lg mb-2xl">
          <h6>
            {{ 'user_details_screen_work_info_section_title' | transloco }}
          </h6>
        </div>

        <div
          class="mb-4xl grid [grid-template-columns:repeat(auto-fill,minmax(20rem,1fr))] gap-lg">
          <div>
            <p class="view-mode-label">
              {{ 'user_form_screen_position_label' | transloco }}
            </p>

            <p class="view-mode-value break-word text-neutral-900">
              {{
                userDetails().placement?.position?.name
                  ?? ('details_not_found_label' | transloco)
              }}
            </p>
          </div>

          <div>
            <p class="view-mode-label">
              {{ 'user_details_screen_legal_entity_label' | transloco }}
            </p>

            <p class="view-mode-value break-word text-neutral-900">
              {{
                userDetails().placement?.position?.legal_entity?.name
                  ?? ('details_not_found_label' | transloco)
              }}
            </p>
          </div>

          <div>
            <p class="view-mode-label">
              {{ 'user_details_screen_department_label' | transloco }}
            </p>

            <p class="view-mode-value break-word text-neutral-900">
              {{
                userDetails().placement?.department?.name
                  ?? ('details_not_found_label' | transloco)
              }}
            </p>
          </div>

          <div>
            <p class="view-mode-label">
              {{ 'user_details_screen_job_title_label' | transloco }}
            </p>

            <p class="view-mode-value break-word text-neutral-900">
              {{
                userDetails().placement?.job_title?.name
                  ?? ('details_not_found_label' | transloco)
              }}
            </p>
          </div>

          <div>
            <p class="view-mode-label">
              {{ 'user_details_screen_direct_manager_label' | transloco }}
            </p>

            <p class="view-mode-value break-word text-neutral-900">
              {{
                userDetails().placement?.direct_manager?.label
                  ?? ('details_not_found_label' | transloco)
              }}
            </p>
          </div>
        </div>
      </section>

      <section data-test="user-details-section" class="block mt-5xl">
        <div
          class="flex items-center justify-between border-b border-neutral-200 pb-lg">
          <div class="flex items-center gap-lg">
            <h6 class="text-neutral-900 font-semibold text-lg px-lg">
              {{ 'user_details_screen_groups_info_section_title' | transloco }}
            </h6>

            <span class="bg-primary-50 rounded-2xl">
              <p class="text-primary-700 px-md py-x-sm font-medium">
                {{ cardListTotalItems() }}
              </p>
            </span>
          </div>

          <div>
            <div class="search-input relative flex gap-md items-center">
              <label
                class="flex items-center w-full border border-neutral-300 rounded-md text-sm p-md">
                <input
                  type="text"
                  [id]="'search'"
                  [placeholder]="'search_by_name_placeholder' | transloco"
                  [style.cursor]="
                    !assignedList().length && !searchTerm() ? 'not-allowed' : ''
                  "
                  [disabled]="!assignedList().length && !searchTerm()"
                  class="bg-transparent text-base w-full pe-2xl placeholder:text-sm placeholder:text-neutral-500"
                  [ngModel]="searchTerm()"
                  (ngModelChange)="onSearchTermChange($event)" />

                <div
                  class="icon absolute end-3 inset-y-3 cursor-pointer flex items-center">
                  <lib-search-icon [iconClass]="'size-5 text-neutral-500'" />
                </div>
              </label>
            </div>
          </div>
        </div>

        <div class="my-lg">
          @if (isCardListLoading()) {
            <div class="flex justify-center items-center h-full my-4xl">
              <lib-loader />
            </div>
          } @else {
            <lib-group-user-card
              [list]="assignedList()"
              [itemType]="'Group'"
              [mode]="'view'" />
          }
        </div>

        @if (assignedList().length) {
          <div class="mt-2xl">
            <lib-paginator
              [sizeOptionsLabel]="
                'pagination_number_of_rows_per_page_label' | transloco
              "
              [nextBtnLabel]="'pagination_next_button_label' | transloco"
              [previousBtnLabel]="
                'pagination_previous_button_label' | transloco
              "
              [currentPage]="cardListCurrentPage()"
              [totalPages]="cardListTotalPages()"
              [totalItems]="cardListTotalItems()"
              [currentSize]="15"
              (goTo)="handleCardListPagination($event)"
              (next)="handleCardListPagination($event)"
              (previous)="handleCardListPagination($event)" />
          </div>
        }
      </section>
    </div>
  </div>
}
